var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"error-page"},[_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"10","lg":"8","xl":"6"}},[_c(_vm.errorPage,{tag:"component",attrs:{"error":_vm.error}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }